import React from 'react';
import { Container, Row, Col, Accordion } from 'react-bootstrap';

const Services = () => {
  const services = [
    {
      title: "Golf Academy",
      description: "Personalized coaching programs with certified PGA professionals. Transform your game through systematic training and modern techniques.",
      features: [
        "Personalized coaching programs",
        "Youth development programs",
        "Professional tournament training",
        "Mental game coaching",
        "Group & private lessons",
        "Performance analysis"
      ],
      image: "https://plus.unsplash.com/premium_photo-1661362222640-c262dad02bab?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      icon: "🏌️",
      color: "#1F3D2B"
    },
    {
      title: "Golf Simulators",
      description: "Cutting-edge technology with real-time swing analysis. Practice on world-class courses regardless of weather conditions.",
      features: [
        "Advanced swing analysis",
        "Virtual course play",
        "Data-driven improvement",
        "Multiplayer experiences",
        "Tournament simulation",
        "Progress tracking"
      ],
      image: "https://emvwr2994ad.exactdn.com/wp-content/uploads/2022/02/golfsimulator-stockholm.jpg?strip=all&quality=77",
      icon: "📊",
      color: "#B59A5A"
    },
    {
      title: "Pro Shop",
      description: "Premium equipment with expert custom fitting. Find the perfect gear to enhance your performance on the course.",
      features: [
        "Custom club fitting",
        "Premium equipment",
        "Apparel & accessories",
        "Equipment maintenance",
        "Gear customization",
        "Expert consultations"
      ],
      image: "https://images.squarespace-cdn.com/content/v1/6089dcbaf5342302edc405dd/1628734033438-MQ6DRVX55NC93IVMIRJG/unsplash-image-ZnBBDPO2mbQ.jpg",
      icon: "🛒",
      color: "#1F3D2B"
    },
    {
      title: "Membership Programs",
      description: "Flexible membership options designed for golfers of all levels. Access premium facilities and exclusive benefits.",
      features: [
        "Flexible membership tiers",
        "Unlimited simulator access",
        "Priority booking",
        "Member events",
        "Guest privileges",
        "Discounts on services"
      ],
      image: "https://images.unsplash.com/photo-1535131749006-b7f58c99034b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      icon: "🎯",
      color: "#B59A5A"
    },
    {
      title: "Corporate Events",
      description: "Host memorable golf events for your team or clients. Perfect for networking, team building, and corporate entertainment.",
      features: [
        "Team building events",
        "Client entertainment",
        "Tournament organization",
        "Catering services",
        "Branding opportunities",
        "Professional photography"
      ],
      image: "https://images.unsplash.com/photo-1575361204480-aadea25e6e68?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      icon: "🏢",
      color: "#1F3D2B"
    },
    {
      title: "Junior Programs",
      description: "Specialized training for young golfers. Nurture talent from an early age with age-appropriate coaching.",
      features: [
        "Age-appropriate training",
        "School partnerships",
        "Tournament preparation",
        "Scholarship opportunities",
        "Parent-child programs",
        "Summer camps"
      ],
      image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      icon: "👦",
      color: "#B59A5A"
    }
  ];

  const technologyDetails = [
    {
      title: "Golf Simulator Technology",
      content: "Our advanced simulators feature cutting-edge technology:",
      features: [
        "High-speed cameras for precise ball tracking",
        "Infrared sensors for accurate club data",
        "4K projection for immersive course experience",
        "Real-time swing analysis with instant feedback",
        "Library of 150+ world-class courses",
        "Multiplayer tournaments and leagues"
      ],
      image: "https://emvwr2994ad.exactdn.com/wp-content/uploads/2022/02/golfsimulator-stockholm.jpg?strip=all&quality=77"
    },
    {
      title: "Coaching System Technology",
      content: "Revolutionary coaching tools for modern golfers:",
      features: [
        "3D motion capture for biomechanical analysis",
        "Pressure mat for weight distribution tracking",
        "Video analysis with slow-motion playback",
        "Mobile app for progress tracking",
        "AI-powered swing recommendations",
        "Virtual reality training modules"
      ],
      image: "https://images.pexels.com/photos/31212256/pexels-photo-31212256.jpeg?cs=srgb&dl=pexels-swingzone-swingzone-2150575315-31212256.jpg&fm=jpg"
    },
    {
      title: "Custom Equipment Technology",
      content: "State-of-the-art fitting technology for perfect equipment:",
      features: [
        "Launch monitor data integration",
        "Laser measurement for precise specifications",
        "3D body scanning for optimal fitting",
        "CAD design for custom club manufacturing",
        "Material science optimization",
        "Performance prediction algorithms"
      ],
      image: "https://images.unsplash.com/photo-1592659762303-90081d34b277?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
    }
  ];

  return (
    <>
      {/* Hero Section with Animation */}
      <section style={{
        height: '70vh',
        background: 'linear-gradient(rgba(31, 61, 43, 0.85), rgba(31, 61, 43, 0.95)), url(https://plus.unsplash.com/premium_photo-1661362222640-c262dad02bab?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D) center/cover no-repeat fixed',
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        overflow: 'hidden'
      }}>
        {/* Animated Background Elements */}
        <div className="position-absolute top-0 start-0 w-100 h-100" style={{
          background: 'radial-gradient(circle at 30% 30%, rgba(181, 154, 90, 0.1) 0%, transparent 50%)',
          animation: 'pulse 4s ease-in-out infinite'
        }}></div>

        <Container>
          <Row className="justify-content-center">
            <Col lg={10} className="text-center text-white">
              <div className="animate-fade-in-up">
                <h1 className="display-3 fw-bold mb-4" style={{ color: "#B59A5A" }}>Premium Golf Services</h1>
                <p className="lead mb-4" style={{ fontSize: '1.5rem', opacity: 0.9 }}>
                  Experience golf like never before with our comprehensive suite of services designed for every skill level
                </p>
                <div className="d-flex justify-content-center gap-3">
                  <button className="btn-gold-filled btn-lg px-5 py-3">Book a Service</button>
                  <button className="btn-gold btn-lg px-5 py-3">View Pricing</button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>

      </section>

      {/* Services Grid Section */}
      <section className="section-padding">
        <Container>
          <Row className="mb-5">
            <Col lg={8} className="mx-auto text-center">
              <div className="animate-fade-in-up">
                <h2 className="display-5 fw-bold mb-3">Comprehensive Golf Solutions</h2>
                <p className="lead" style={{ color: '#666' }}>
                  From beginners to professionals, we offer everything you need to elevate your game in one premium location
                </p>
              </div>
            </Col>
          </Row>

          {/* Services Grid */}
          <Row className="g-4">
            {services.map((service, index) => (
              <Col lg={4} md={6} key={index}>
                <div className="animate-fade-in-up" style={{ animationDelay: `${index * 0.1}s` }}>
                  <div className="service-card h-100" style={{
                    borderRadius: '15px',
                    overflow: 'hidden',
                    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.08)',
                    transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                    background: 'white'
                  }}>
                    {/* Service Image */}
                    <div style={{
                      height: '200px',
                      background: `url(${service.image}) center/cover no-repeat`,
                      position: 'relative'
                    }}>
                      {/* Overlay Gradient */}
                      <div style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: 'linear-gradient(to bottom, transparent 50%, rgba(0,0,0,0.7) 100%)'
                      }}></div>

                      {/* Icon Badge */}
                      <div style={{
                        position: 'absolute',
                        top: '20px',
                        right: '20px',
                        width: '60px',
                        height: '60px',
                        backgroundColor: service.color,
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '1.8rem',
                        color: 'white',
                        boxShadow: '0 4px 15px rgba(0,0,0,0.2)'
                      }}>
                        {service.icon}
                      </div>
                    </div>

                    {/* Service Content */}
                    <div className="p-4">
                      <h3 className="h4 mb-3" style={{ color: 'var(--primary-green)' }}>
                        {service.title}
                      </h3>

                      <p style={{ color: '#666', marginBottom: '1.5rem' }}>
                        {service.description}
                      </p>

                      <div className="mb-4">
                        <h5 className="h6 mb-3" style={{ color: 'var(--muted-gold)' }}>Key Features:</h5>
                        <ul className="list-unstyled" style={{ color: '#666' }}>
                          {service.features.map((feature, idx) => (
                            <li key={idx} className="mb-2 d-flex align-items-start">
                              <span style={{
                                color: 'var(--muted-gold)',
                                marginRight: '10px',
                                fontSize: '0.8rem',
                                lineHeight: '1.4'
                              }}>✓</span>
                              <span>{feature}</span>
                            </li>
                          ))}
                        </ul>
                      </div>

                      <div className="d-flex justify-content-between align-items-center mt-4 pt-3 border-top">
                        <button className="btn-gold" style={{ padding: '8px 20px' }}>
                          Learn More
                        </button>
                        <span className="small text-muted">Starting at ₹5,000/month</span>
                      </div>
                    </div>

                    {/* Hover Effect */}
                    <style jsx>{`
                      .service-card:hover {
                        transform: translateY(-10px);
                        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
                      }
                      
                      .service-card:hover h3 {
                        color: var(--muted-gold) !important;
                        transition: color 0.3s ease;
                      }
                    `}</style>
                  </div>
                </div>
              </Col>
            ))}
          </Row>

          {/* CTA Section */}
          <Row className="mt-5">
            <Col lg={8} className="mx-auto text-center">
              <div className="p-5 rounded" style={{
                background: 'linear-gradient(135deg, var(--primary-green) 0%, #2a4d3b 100%)',
                color: 'white'
              }}>
                <h3 className="h2 mb-3">Ready to Elevate Your Game?</h3>
                <p className="mb-4" style={{ opacity: 0.9 }}>
                  Schedule a free consultation with our golf professionals and discover the perfect program for your needs.
                </p>
                <div className="d-flex flex-wrap justify-content-center gap-3">
                  <button className="btn-gold-filled" style={{ background: 'white', color: 'var(--primary-green)' }}>
                    Book Free Consultation
                  </button>
                  <button className="btn-gold" style={{ borderColor: 'white', color: 'white' }}>
                    Call Now: +91 8130804488
                  </button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Technology Deep Dive Section */}
      <section className="section-padding bg-soft-sage">
        <Container>
          <Row className="mb-5">
            <Col lg={8} className="mx-auto text-center">
              <h2 className="display-5 fw-bold mb-3">Cutting-Edge Technology</h2>
              <p className="lead" style={{ color: '#666' }}>
                Experience the future of golf with our state-of-the-art technological innovations
              </p>
            </Col>
          </Row>

          {/* Technology Cards */}
          <Row className="g-4">
            {technologyDetails.map((tech, index) => (
              <Col lg={4} key={index}>
                <div className="animate-fade-in-up" style={{ animationDelay: `${index * 0.1}s` }}>
                  <div className="h-100" style={{
                    background: 'white',
                    borderRadius: '15px',
                    overflow: 'hidden',
                    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.08)'
                  }}>
                    {/* Tech Image */}
                    <div style={{
                      height: '200px',
                      background: `url(${tech.image}) center/cover no-repeat`
                    }}></div>

                    {/* Tech Content */}
                    <div className="p-4">
                      <h3 className="h4 mb-3" style={{ color: 'var(--primary-green)' }}>
                        {tech.title}
                      </h3>

                      <p style={{ color: '#666', marginBottom: '1.5rem' }}>
                        {tech.content}
                      </p>

                      <div>
                        <ul style={{ color: '#666' }}>
                          {tech.features.map((feature, idx) => (
                            <li key={idx} className="mb-2">
                              {feature}
                            </li>
                          ))}
                        </ul>
                      </div>

                      <div className="mt-4 pt-3 border-top">
                        <button className="btn-gold w-100">
                          Explore Technology
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>

          {/* Interactive Accordion */}
          <Row className="mt-5">
            <Col lg={10} className="mx-auto">
              <div className="bg-white rounded p-4">
                <h3 className="h4 mb-4 text-center" style={{ color: 'var(--primary-green)' }}>
                  Frequently Asked Questions
                </h3>

                <Accordion flush>
                  {[
                    {
                      question: "What makes your golf academy different from others?",
                      answer: "Our academy uses a systematic coaching approach that moves away from traditional 'assembly line' training. We combine personalized coaching with cutting-edge technology, including 3D motion capture and AI-powered swing analysis, ensuring each golfer receives tailored training based on their unique biomechanics and goals."
                    },
                    {
                      question: "How accurate are your golf simulators?",
                      answer: "Our simulators use high-speed cameras and infrared sensors with millimeter accuracy. They track over 20 data points including ball speed, launch angle, spin rate, and club path. The technology is so precise that many professional golfers use similar systems for their training."
                    },
                    {
                      question: "Do you offer custom club fitting for beginners?",
                      answer: "Absolutely! In fact, we recommend custom fitting for golfers of all levels. Properly fitted clubs can significantly improve your game and prevent injuries. Our fitting process includes 3D body scanning, launch monitor data analysis, and expert consultation to ensure perfect equipment match."
                    },
                    {
                      question: "What membership options do you offer?",
                      answer: "We offer flexible membership tiers ranging from basic simulator access to premium packages including unlimited coaching, priority booking, and exclusive member events. Each tier is designed to meet different needs and budgets, with options for individuals, families, and corporate groups."
                    }
                  ].map((faq, index) => (
                    <Accordion.Item eventKey={index.toString()} key={index} className="border-0 mb-2">
                      <Accordion.Header className="accordion-button-custom px-3 py-3">
                        {faq.question}
                      </Accordion.Header>
                      <Accordion.Body className="px-3 py-3" style={{ color: '#666' }}>
                        {faq.answer}
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Pricing Table Section */}
      <section className="section-padding">
        <Container>
          <Row className="mb-5">
            <Col lg={8} className="mx-auto text-center">
              <h2 className="display-5 fw-bold mb-3">Service Packages</h2>
              <p className="lead" style={{ color: '#666' }}>
                Choose the perfect package for your golf journey
              </p>
            </Col>
          </Row>

          <Row className="g-4">
            {[
              {
                name: "Starter",
                price: "₹5,999",
                period: "per month",
                features: ["4 simulator sessions", "1 coaching session", "Basic equipment access", "Progress tracking"],
                best: false
              },
              {
                name: "Progressive",
                price: "₹12,999",
                period: "per month",
                features: ["Unlimited simulator access", "4 coaching sessions", "Advanced equipment", "Tournament entry", "Priority booking"],
                best: true
              },
              {
                name: "Elite",
                price: "₹24,999",
                period: "per month",
                features: ["All Progressive features", "Unlimited coaching", "Custom club fitting", "Personalized training plan", "Member events", "Guest passes"],
                best: false
              }
            ].map((plan, index) => (
              <Col lg={4} key={index}>
                <div className={`h-100 p-4 rounded text-center ${plan.best ? 'border-gold' : 'border'}`} style={{
                  borderWidth: plan.best ? '2px' : '1px',
                  borderColor: plan.best ? 'var(--muted-gold)' : 'rgba(31, 61, 43, 0.1)',
                  position: 'relative',
                  background: 'white'
                }}>
                  {plan.best && (
                    <div className="position-absolute top-0 start-50 translate-middle-x px-3 py-1 rounded-bottom" style={{
                      backgroundColor: 'var(--muted-gold)',
                      color: 'white',
                      fontSize: '0.8rem',
                      fontWeight: 'bold'
                    }}>
                      MOST POPULAR
                    </div>
                  )}

                  <h3 className="h4 mb-3" style={{ color: 'var(--primary-green)' }}>
                    {plan.name}
                  </h3>

                  <div className="mb-4">
                    <span className="display-6 fw-bold" style={{ color: 'var(--muted-gold)' }}>
                      {plan.price}
                    </span>
                    <span className="text-muted">/{plan.period}</span>
                  </div>

                  <ul className="list-unstyled mb-4" style={{ color: '#666' }}>
                    {plan.features.map((feature, idx) => (
                      <li key={idx} className="mb-3">
                        <span style={{ color: 'var(--muted-gold)', marginRight: '8px' }}>✓</span>
                        {feature}
                      </li>
                    ))}
                  </ul>

                  <button className={`btn ${plan.best ? 'btn-gold-filled' : 'btn-gold'} w-100`}>
                    Choose Plan
                  </button>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Add CSS animations */}
      <style jsx>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes pulse {
          0%, 100% {
            opacity: 0.1;
          }
          50% {
            opacity: 0.2;
          }
        }
        
        @keyframes bounce {
          0%, 20%, 50%, 80%, 100% {
            transform: translateY(0);
          }
          40% {
            transform: translateY(-10px);
          }
          60% {
            transform: translateY(-5px);
          }
        }
        
        .animate-fade-in-up {
          animation: fadeInUp 0.6s ease-out forwards;
        }
        
        .animate-bounce {
          animation: bounce 2s infinite;
        }
        
        .border-gold {
          border-color: var(--muted-gold) !important;
        }
      `}</style>
    </>
  );
};

export default Services;